import React, { useEffect, useState } from "react";
import LoadingPage from "../Loading/loading";
import { useNavigate, useParams } from "react-router-dom";
import { Cookies } from "react-cookie";
import { ToastContainer, toast } from "react-toastify";
import {
  createPhase,
  createPrimary,
  deletePhase,
  deleteProperty,
  getParents,
  getProject,
  getProperties,
  getProperty,
  updatePrimary,
  updateProperty,
} from "../../api/Primary";

const ViewPropertyPage = () => {
  const params = useParams();
  const navigate = useNavigate();
  const cookie = new Cookies();
  const [loading, setLoading] = useState();
  const [isSuper, setIsSuper] = useState(cookie.get("isSuper"));
  const [type, setType] = useState("");
  const [types, setTypes] = useState([]);
  const [finishings, setFinishings] = useState([]);
  const [property, setProperty] = useState(null);
  const [isDisable, setIsDisable] = useState(true);
  const [deleteUnit, setDeleteUnit] = useState(false);
  const [images, setImages] = useState([]);
  const [oldImages, setOldImages] = useState([]);

  useEffect(() => {
    propropertyGet();
  }, []);

  const propropertyGet = () => {
    setProperty(null);
    setType("");
    getProperty(params.id).then((result) => {
      setProperty(result.data.property);
      setTypes(result.data.typesProperties);
      setFinishings(result.data.finishing);
      setType(result.data.property.propertyType.name);
    });
  };

  const handleChange = (e) => {
    e.target.setCustomValidity("");
    const { name, value } = e.target;
    setProperty((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleChangePaymentPlan = (index, field, value) => {
    setProperty((prev) => {
      const updatedPlans = [...prev.paymentPlans];
      updatedPlans[index] = {
        ...updatedPlans[index],
        [field]: value,
      };

      return {
        ...prev,
        paymentPlans: updatedPlans,
      };
    });
  };

  const removePaymentPlan = (indexToRemove) => {
    if (property.paymentPlans.length > 1) {
      setProperty((prev) => ({
        ...prev,
        paymentPlans: prev.paymentPlans.filter(
          (_, index) => index !== indexToRemove,
        ),
      }));
    }
  };

  const addPaymentPlan = () => {
    setProperty((prev) => ({
      ...prev,
      paymentPlans: [
        ...prev.paymentPlans,
        {
          singleInstallmentAmount: 0,
          years: 0,
          unitPrice: 0,
          downPayment: 0,
          downPaymentMonth1: 0,
          downPaymentMonth3: 0,
          downPaymentMonth6: 0,
        },
      ],
    }));
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);

    const validTypes = ["image/jpg", "image/png", "image/jpeg"];
    const invalidFiles = files.filter(
      (file) => !validTypes.includes(file.type),
    );

    if (invalidFiles.length > 0) {
      alert("Only JPG, PNG, or JPEG files are allowed");
      return;
    }

    setImages((prevImages) => [...prevImages, ...files]);
  };

  const removeImage = (index) => {
    const imageToRemove = property.floorPlans[index];
    setProperty((prev) => ({
      ...prev,
      floorPlans: prev.floorPlans.filter((_, i) => i !== index),
    }));
    setOldImages((prev) => [...prev, imageToRemove]);
  };

  const removeImageFile = (index) => {
    setImages((prev) => prev.filter((_, i) => i !== index));
  };

  const handleSubmit = () => {
    setLoading(true);
    const updatedPaymentPlans = property.paymentPlans.map((plan) => {
      const minPrice = Number(property.minPrice);
      const downPayment = Number(plan.downPayment || 0);
      const downPaymentMonth1 = Number(plan.downPaymentMonth1 || 0);
      const years = Number(plan.years || 1);

      return {
        ...plan,
        unitPrice: minPrice,
        singleInstallmentAmount: Math.round(
          ((minPrice - downPayment - downPaymentMonth1) * 3) / (years * 12),
        ),
      };
    });

    setProperty((prev) => ({
      ...prev,
      paymentPlans: updatedPaymentPlans,
    }));
    const formBack = new FormData();
    formBack.append("name", property.name);
    formBack.append("finishing", property.finishing);
    formBack.append("minPrice", property.minPrice);
    formBack.append("maxPrice", property.minPrice);
    formBack.append("propertyType", type);
    formBack.append("numberOfBedrooms", property.numberOfBedrooms);
    formBack.append("numberOfBathrooms", property.numberOfBathrooms);
    formBack.append("minUnitArea", property.minUnitArea);
    formBack.append("maxUnitArea", property.minUnitArea);
    formBack.append("deliveryDate", property.deliveryDate);
    formBack.append("paymentPlans", JSON.stringify(updatedPaymentPlans));
    formBack.append("oldImages", JSON.stringify(oldImages));
    for (let i = 0; i < images.length; i++) {
      formBack.append("floorPlans", images[i]);
    }

    updateProperty(params.id, formBack).then((result) => {
      if (result.data.message === "Property is updated") {
        toast.success("Property is updated", {
          position: "top-right",
        });
        propropertyGet();
        setIsDisable(true);
      }
      setLoading(false);
    });
  };

  const inputStyle = {
    position: "absolute",
    width: "1px",
    height: "1px",
    padding: 0,
    margin: -1,
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    border: 0,
  };

  const labelStyle = {
    display: "inline-block",
    padding: "10px 20px",
    backgroundColor: "#4CAF50",
    color: "white",
    borderRadius: "4px",
    cursor: "pointer",
    fontSize: "16px",
    fontWeight: "500",
    transition: "background-color 0.3s",
    border: "none",
    textAlign: "center",
    ":hover": {
      backgroundColor: "#45a049",
    },
  };

  const labelDeleteStyle = {
    display: "inline-block",
    padding: "10px",
    backgroundColor: "red",
    color: "white",
    borderRadius: "4px",
    cursor: "pointer",
    fontSize: "16px",
    fontWeight: "500",
    transition: "background-color 0.3s",
    border: "none",
    textAlign: "center",
    ":hover": {
      backgroundColor: "#45a049",
    },
    margin: "0px",
  };

  return (
    <div className="main-content">
      {property === null ? (
        <LoadingPage />
      ) : (
        <div className="add-brokers-guideline">
          <label htmlFor="image">Floor plans</label>
          <div className="image-previews">
            {property.floorPlans.map((image, imageIndex) => (
              <div key={image} className="preview-item">
                <img src={image} alt={`Preview ${imageIndex}`} />
                {!isDisable && (
                  <button onClick={() => removeImage(imageIndex)}>×</button>
                )}
              </div>
            ))}
            {images.map((image, imageIndex) => (
              <div key={image} className="preview-item">
                <img
                  src={URL.createObjectURL(image)}
                  alt={`Preview ${imageIndex}`}
                />
                <button onClick={() => removeImageFile(imageIndex)}>×</button>
              </div>
            ))}
          </div>

          {!isDisable && (
            <div className="form-group">
              <div style={{ position: "relative", marginTop: "16px" }}>
                <input
                  type="file"
                  id="images"
                  name="images"
                  onChange={handleFileChange}
                  multiple
                  accept="image/jpg, image/png, image/jpeg"
                  style={inputStyle}
                />
                <label htmlFor="images" style={labelStyle}>
                  Choose Images
                </label>
              </div>
            </div>
          )}

          <div className="form-group">
            <label htmlFor="name">Inventory name</label>
            <input
              type="text"
              id="name"
              name="name"
              value={property.name}
              onChange={handleChange}
              placeholder="Enter Inventory name"
              disabled={isDisable}
              required
              onInvalid={(e) =>
                e.target.setCustomValidity("Inventory name is required")
              }
            />
          </div>

          <div className="form-group">
            <label
              htmlFor="areaName"
              style={{
                display: "block",
                marginBottom: "8px",
                fontWeight: "500",
              }}
            >
              Finishing
            </label>
            <select
              className="form-select form-control form-select-lg border border-dark"
              aria-label="Select Finishing"
              name="areaName" // Changed from type2 to be more descriptive
              value={property.finishing}
              disabled={isDisable}
              onChange={(e) => {
                e.target.setCustomValidity("");
                setProperty({
                  ...property,
                  finishing: e.target.value,
                });
              }}
              style={{
                width: "100%",
                padding: "10px",
                border: "1px solid #ddd",
                borderRadius: "6px",
                fontSize: "16px",
                backgroundColor: "#fff",
                cursor: "pointer",
              }}
              required
              onInvalid={(e) =>
                e.target.setCustomValidity("Location is required")
              }
            >
              <option disabled value="">
                Select Finishing
              </option>
              {finishings?.map((item) => (
                <option key={item} value={item}>
                  {item
                    ?.replaceAll("-", " ")
                    ?.toLowerCase()
                    ?.replace(/\b\w/g, (l) => l.toUpperCase())}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label
              htmlFor="areaName"
              style={{
                display: "block",
                marginBottom: "8px",
                fontWeight: "500",
              }}
            >
              Type
            </label>
            <select
              className="form-select form-control form-select-lg border border-dark"
              aria-label="Select type"
              name="type" // Changed from type2 to be more descriptive
              value={type}
              disabled={isDisable}
              onChange={(e) => {
                e.target.setCustomValidity("");
                setType(e.target.value);
              }}
              style={{
                width: "100%",
                padding: "10px",
                border: "1px solid #ddd",
                borderRadius: "6px",
                fontSize: "16px",
                backgroundColor: "#fff",
                cursor: "pointer",
              }}
              required
              onInvalid={(e) => e.target.setCustomValidity("Type is required")}
            >
              <option disabled value="">
                Select Type
              </option>
              {types?.map((item) => (
                <option key={item} value={item}>
                  {item
                    ?.replaceAll("-", " ")
                    ?.toLowerCase()
                    ?.replace(/\b\w/g, (l) => l.toUpperCase())}
                </option>
              ))}
            </select>
          </div>

          <div
            className="choices-container"
            style={{
              display: "flex",
              width: "100%",
              gap: "15px", // Better than space-between for consistent spacing
              flexWrap: "wrap",
            }}
          >
            <div
              className="form-group"
              style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}
            >
              <label htmlFor="numberOfBedrooms">Number Of Bedrooms</label>
              <input
                type="number"
                id="numberOfBedrooms"
                name="numberOfBedrooms"
                value={property.numberOfBedrooms}
                disabled={isDisable}
                onChange={handleChange}
                placeholder="Enter Number Of Bedrooms"
                required
                onInvalid={(e) =>
                  e.target.setCustomValidity("Number Of Bedrooms is required")
                }
              />
            </div>
            <div
              className="form-group"
              style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}
            >
              <label htmlFor="numberOfBathrooms">Number Of Bathrooms</label>
              <input
                type="number"
                id="numberOfBathrooms"
                name="numberOfBathrooms"
                value={property.numberOfBathrooms}
                onChange={handleChange}
                disabled={isDisable}
                placeholder="Enter Number Of Bathrooms"
                required
                onInvalid={(e) =>
                  e.target.setCustomValidity("Number Of Bathrooms is required")
                }
              />
            </div>
          </div>

          <div
            className="choices-container"
            style={{
              display: "flex",
              width: "100%",
              gap: "15px", // Better than space-between for consistent spacing
              flexWrap: "wrap",
            }}
          >
            <div
              className="form-group"
              style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}
            >
              <label htmlFor="minPrice">Price</label>
              <input
                type="number"
                id="minPrice"
                name="minPrice"
                value={property.minPrice}
                disabled={isDisable}
                onChange={handleChange}
                placeholder="Enter Price"
                required
                onInvalid={(e) =>
                  e.target.setCustomValidity("Price is required")
                }
              />
            </div>

            <div
              className="form-group"
              style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}
            >
              <label htmlFor="minUnitArea">Unit Area</label>
              <input
                type="number"
                id="minUnitArea"
                name="minUnitArea"
                value={property.minUnitArea}
                disabled={isDisable}
                onChange={handleChange}
                placeholder="Enter Unit Area"
                required
                onInvalid={(e) =>
                  e.target.setCustomValidity("Unit Area is required")
                }
              />
            </div>
          </div>

          <div
            className="form-group"
            style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}
          >
            <label htmlFor="deliveryDate">Delivery Date</label>
            <input
              type="date"
              id="deliveryDate"
              name="deliveryDate"
              value={property.deliveryDate.split("T")[0]}
              onChange={handleChange}
              disabled={isDisable}
              placeholder="Enter Delivery Date"
              required
              onInvalid={(e) =>
                e.target.setCustomValidity("Delivery Date is required")
              }
            />
          </div>

          <div
            style={{
              display: "block",
              marginBottom: "8px",
              fontWeight: "bold",
              color: "#555",
            }}
          >
            <label htmlFor="paymentPlans">Payment Plans</label>
          </div>

          {property.paymentPlans.map((item, pIndex) => (
            <div
              key={pIndex}
              style={{
                display: "flex",
                width: "100%",
                gap: "15px", // Better than space-between for consistent spacing
                flexWrap: "wrap",
                border: "2px solid #3498db",
                borderRadius: "4px",
                padding: "10px",
                marginBottom: "5px",
              }}
            >
              <div className="choices-container">
                <div
                  className="form-group"
                  style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}
                >
                  <label htmlFor="years">Years</label>
                  <input
                    type="number"
                    id="years"
                    name="years"
                    value={item.years}
                    disabled={isDisable}
                    onChange={(e) => {
                      e.target.setCustomValidity("");
                      handleChangePaymentPlan(pIndex, "years", e.target.value);
                    }}
                    placeholder={`Enter Years (${pIndex + 1})      %`}
                    required={true}
                    onInvalid={(e) => {
                      e.target.setCustomValidity(
                        `Years ${pIndex + 1} is required`,
                      );
                    }}
                  />
                </div>

                <div
                  className="form-group"
                  style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}
                >
                  <label htmlFor="downPayment">Down Payment</label>
                  <input
                    type="number"
                    id="downPayment"
                    name="downPayment"
                    value={item.downPayment}
                    disabled={isDisable}
                    onChange={(e) => {
                      e.target.setCustomValidity("");
                      handleChangePaymentPlan(
                        pIndex,
                        "downPayment",
                        e.target.value,
                      );
                    }}
                    placeholder={`Enter Down Payment (${pIndex + 1})      %`}
                    required={true}
                    onInvalid={(e) => {
                      e.target.setCustomValidity(
                        `Down Payment ${pIndex + 1} is required`,
                      );
                    }}
                  />
                </div>

                <div
                  className="form-group"
                  style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}
                >
                  <label htmlFor="downPaymentMonth1">
                    Down Payment Month 1
                  </label>
                  <input
                    type="number"
                    id="downPaymentMonth1"
                    name="downPaymentMonth1"
                    value={item.downPaymentMonth1}
                    disabled={isDisable}
                    onChange={(e) => {
                      e.target.setCustomValidity("");
                      handleChangePaymentPlan(
                        pIndex,
                        "downPaymentMonth1",
                        e.target.value,
                      );
                    }}
                    placeholder={`Enter Down Payment Month 1 (${pIndex + 1})      %`}
                    required={true}
                    onInvalid={(e) => {
                      e.target.setCustomValidity(
                        `Down Payment Month 1 ${pIndex + 1} is required`,
                      );
                    }}
                  />
                </div>
              </div>
              {!isDisable && (
                <>
                  {property.paymentPlans.length > 1 && (
                    <div
                      className="form-group"
                      style={{
                        flex: "1 1 calc(50% - 15px)",
                        minWidth: "250px",
                      }}
                    >
                      <label
                        htmlFor="addPaymentPlan"
                        style={labelDeleteStyle}
                        onClick={() => removePaymentPlan(pIndex)}
                      >
                        Remove this payment plan
                      </label>
                    </div>
                  )}
                </>
              )}
            </div>
          ))}
          {!isDisable && (
            <div
              className="form-group"
              style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}
            >
              <label
                htmlFor="addPaymentPlan"
                style={labelStyle}
                onClick={() => addPaymentPlan()}
              >
                Add more payment plan
              </label>
            </div>
          )}

          {loading ? (
            <div
              style={{
                width: "100%",
                justifyContent: "center",
                display: "flex",
              }}
            >
              <div className="spinner"></div>
            </div>
          ) : (
            <>
              {deleteUnit ? (
                <div
                  style={{
                    border: "1px solid #ddd",
                    borderRadius: "4px",
                    padding: "5px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <p className="line">
                    Are you sure you want to delete this Inventory?{" "}
                  </p>
                  <div className="card-info">
                    <div className="card-actions">
                      <button
                        onClick={() => {
                          setDeleteUnit(false);
                        }}
                        className="action-btn accept-btn"
                      >
                        No
                      </button>
                    </div>
                    <div className="card-actions">
                      <button
                        onClick={() => {
                          deleteProperty(params.id).then((data) => {
                            navigate(-1);
                          });
                        }}
                        className="action-btn remove-btn"
                      >
                        Yes
                      </button>
                    </div>
                  </div>
                </div>
              ) : (
                <div
                  className="choices-container"
                  style={{
                    display: "flex",
                    width: "100%",
                    gap: "15px", // Better than space-between for consistent spacing
                    flexWrap: "wrap",
                    justifyContent: "center",
                  }}
                >
                  <button
                    onClick={() => {
                      if (isDisable) {
                        setDeleteUnit(true);
                      } else {
                        setIsDisable(true);
                      }
                    }}
                    className="action-btn remove-btn"
                    style={{ width: "45%" }}
                  >
                    {isDisable ? "Delete Inventory" : "Cancel"}
                  </button>
                  <button
                    onClick={() => {
                      if (isDisable) {
                        setIsDisable(false);
                      } else {
                        handleSubmit();
                      }
                    }}
                    className={`action-btn accept-btn`}
                    style={{ width: "45%" }}
                  >
                    Update Inventory
                  </button>
                </div>
              )}
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default ViewPropertyPage;
